import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import Layout from "backend/components/layout";
import lh from "helpers/linkHandler";
import CreateTextForm from "backend/components/authoring/CreateTextForm";

export default function TextCreateContainer() {
  const { t } = useTranslation();
  const { project, refresh } = useOutletContext() || {};

  if (!project) return null;

  return (
    <section>
      <Layout.DrawerHeader
        title={t("texts.create_button_label")}
        instructions={t("texts.create.drawer_instructions")}
      />
      <CreateTextForm
        cancelUrl={lh.link("backendProjectTexts", project.id)}
        projectId={project.id}
        refresh={refresh}
      />
    </section>
  );
}

TextCreateContainer.displayName = "Project.Text.Create";
